/*
 * (c) Copyright Reserved EVRYTHNG Limited 2021. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

import { merge } from '../_snowpack/pkg/lodash.js';
import { captureException } from '../_snowpack/pkg/@sentry/react.js';

// the path to translations will not be checked by the IDE, be careful adding a new path!
const defaultTranslations = {
  'en-GB': './i18n/locales/en-GB/default.json',
  'pt-BR': './i18n/locales/pt-BR/default.json',
};

const translationCache = {};

const getTranslation = async url => {
  const response = await fetch(url);
  return response.json();
};

const getDefaultTranslation = language => {
  return (
    translationCache[language] || getTranslation(defaultTranslations[language])
  );
};

export const request = async (options, url, payload, callback) => {
  const language = url.split('/')[3];
  const isDefault = url.endsWith('default.json');

  try {
    const [translation, defaultTranslation] = await Promise.all([
      getTranslation(url),
      // we need to request the default translation if the current url is not the default url
      isDefault ? {} : getDefaultTranslation(language, isDefault),
    ]);

    if (isDefault) {
      // eslint-disable-next-line fp/no-mutation
      translationCache[language] = translation;
    }
    const data = merge(defaultTranslation, translation);
    callback(null, { status: 200, data: JSON.stringify(data) });
  } catch (err) {
    captureException(err);
    callback(err);
  }
};
